var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'dark-mode': _vm.isDarkMode },attrs:{"id":"app"}},[_c('HomeView',{attrs:{"theme-changed":_vm.themeChanged}}),_c('el-button',{staticClass:"theme-toggle",attrs:{"icon":_vm.isDarkMode ? 'el-icon-sunny' : 'el-icon-moon',"circle":""},on:{"click":_vm.toggleTheme}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }